var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card h-100 w-100 overflow-auto"},[_c('div',{staticClass:"drag-header card-header"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('div',{staticClass:"card-body h-100 w-100"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }